var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrintBlack = function SvgPrintBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    y: 0.008,
    fill: "#00263E",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.046 9.1h-.514V7.955A2.96 2.96 0 0 0 17.578 5h-6.202a2.96 2.96 0 0 0-2.954 2.955V9.1h-.468A2.96 2.96 0 0 0 5 12.055v4.767a2.96 2.96 0 0 0 2.954 2.955h.464v3.747c0 .813.663 1.476 1.475 1.476h9.16c.812 0 1.475-.663 1.475-1.476v-3.747h.518A2.96 2.96 0 0 0 24 16.822v-4.767A2.96 2.96 0 0 0 21.046 9.1M9.536 7.955a1.84 1.84 0 0 1 1.836-1.836h6.198a1.84 1.84 0 0 1 1.835 1.836V9.1H9.537V7.955zm9.873 15.578a.36.36 0 0 1-.356.356h-9.16a.36.36 0 0 1-.356-.356v-6.18h9.872zm3.472-6.707a1.84 1.84 0 0 1-1.835 1.836h-.514v-1.31h.738c.31 0 .56-.248.56-.56 0-.31-.25-.559-.56-.559H7.598a.56.56 0 0 0-.56.56c0 .31.249.56.56.56h.824v1.31h-.468a1.84 1.84 0 0 1-1.835-1.837v-4.767a1.84 1.84 0 0 1 1.835-1.836h13.092a1.84 1.84 0 0 1 1.835 1.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.543 20h6.914c.302 0 .543-.222.543-.5s-.241-.5-.543-.5h-6.914c-.302 0-.543.222-.543.5s.245.5.543.5m6.918 1h-6.918c-.302 0-.543.222-.543.5s.241.5.543.5h6.914c.302 0 .543-.222.543-.5s-.241-.5-.539-.5m3.043-10h-1.008a.496.496 0 0 0-.496.5c0 .278.22.5.496.5h1.008a.496.496 0 0 0 .496-.5c0-.278-.22-.5-.496-.5"
  }))));
};
export default SvgPrintBlack;